module.exports = __webpack_public_path__ + "static/media/PianoScore2-KELsMUSIC.25902d87.jpg";